import { File } from './types';
import type JSZip from 'jszip';

// Lazy load jszip only when needed
let jszipModule: any = null;
const loadJSZip = async () => {
    if (!jszipModule) {
        // Dynamic import - only loads when actually needed
        jszipModule = await import('jszip');
    }
    return jszipModule.default || jszipModule;
};

// Extract files from a zip archive
export const extractZipFile = async (zipFile: globalThis.File): Promise<Array<File>> => {
    const JSZip = await loadJSZip();
    const zip = new JSZip();
    const zipContents = await zip.loadAsync(zipFile);
    const extractedFiles: Array<File> = [];
    
    // Process each file in the zip
    for (const [relativePath, file] of Object.entries(zipContents.files)) {
        // Skip directories
        const zipFileEntry = file as JSZip.JSZipObject;
        if (zipFileEntry.dir) {
            continue;
        }
        
        // Get the file data as blob
        const blob = await zipFileEntry.async('blob');
        const url = URL.createObjectURL(blob);
        
        extractedFiles.push({
            url: url,
            filename: relativePath
        });
    }
    
    return extractedFiles;
};

// Check if a file is a zip file based on its name or type
export const isZipFile = (file: globalThis.File): boolean => {
    const filename = file.name.toLowerCase();
    return filename.endsWith('.zip') || file.type === 'application/zip';
};

// Process an array of files, extracting any zip files and returning all files
export const processFilesWithZipExtraction = async (files: Array<globalThis.File>): Promise<Array<File>> => {
    const processedFiles: Array<File> = [];
    
    for (const file of files) {
        if (isZipFile(file)) {
            // Extract zip file contents
            const extractedFiles = await extractZipFile(file);
            processedFiles.push(...extractedFiles);
        } else {
            // Add non-zip files as-is
            processedFiles.push({
                url: URL.createObjectURL(file),
                filename: file.name
            });
        }
    }
    
    return processedFiles;
}; 